import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const VideoHero = () => {
  const [currentImage, setCurrentImage] = useState(0);
  
  const images = [
    '/images/home/PakMeatTraders/Pak Meat Traders (1).jpg',
    '/images/home/PakMeatTraders/Pak Meat Traders (2).jpg',
    '/images/home/PakMeatTraders/Pak Meat Traders (3).jpg',
    '/images/home/PakMeatTraders/Pak Meat Traders (4).jpg',
    '/images/home/PakMeatTraders/Pak Meat Traders (5).jpg'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000); // Change image every 2.5 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden pt-16">
      {/* Background Images with Very Light Animation */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentImage}
            className="absolute inset-0 w-full h-full"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ 
              duration: 2.0,
              ease: "easeInOut"
            }}
          >
            <img
              src={images[currentImage]}
              alt={`Pak Meat Traders - Premium Halal Beef Export ${currentImage + 1}`}
              title="Pak Meat Traders - Premium Fresh Halal Beef Export from Pakistan"
              className="w-full h-full object-cover"
            />
          </motion.div>
        </AnimatePresence>
        <div className="absolute inset-0 bg-black bg-opacity-70"></div>
      </div>

      {/* Image Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
        {images.map((_, index) => (
          <motion.button
            key={index}
            onClick={() => setCurrentImage(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentImage 
                ? 'bg-white scale-125' 
                : 'bg-white bg-opacity-50 hover:bg-opacity-75'
            }`}
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
            aria-label={`Go to image ${index + 1}`}
          />
        ))}
      </div>

      {/* Content with enhanced animations */}
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <motion.h1
          className="text-4xl md:text-6xl font-bold mb-6"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          Premium Quality
        </motion.h1>
        <motion.h1
          className="text-4xl md:text-6xl font-bold mb-6"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          Fresh Halal Beef
        </motion.h1>
        <motion.p
          className="text-xl md:text-2xl mb-8 font-light"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
        >
          Delivered Worldwide
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.1 }}
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link
              to="/contact-us"
              className="bg-primary text-white px-8 py-4 rounded-md text-md font-semibold hover:bg-blue-700 transition-all duration-300 inline-block"
            >
              Request a Quotation
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default VideoHero;